import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@shadcn/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@shadcn/components/ui/table';
import { Card, CardContent, CardHeader, CardTitle } from '@shadcn/components/ui/card';
import { PlusIcon } from 'lucide-react';
import { AddOnlineSourceDialog } from './components/AddOnlineSourceDialog.js';
import { fetchRegionConfigs } from './RegionConfig.service.js';

function RegionConfigsPage() {
  const [regionConfigs, setRegionConfigs] = useState([]);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const navigate = useHistory();

  useEffect(() => {
    async function loadRegionConfigs() {
      try {
        const data = await fetchRegionConfigs();
        setRegionConfigs(data);
      } catch (error) {
        console.error('Failed to load region configs:', error);
      }
    }
    
    loadRegionConfigs();
  }, []);

  const handleViewDetails = (regionId) => {
    navigate.push(`/region-configs/${regionId}`);
  };

  const handleAddSuccess = (newConfig) => {
    setRegionConfigs([...regionConfigs, newConfig]);
    setIsAddDialogOpen(false);
  };

  return (
    <div className="page-content ">
      <div className="w-full px-3 mx-auto xl:max-w-[85%] mb-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-2xl font-bold">Region Configs</CardTitle>
          <Button onClick={() => setIsAddDialogOpen(true)}>
            <PlusIcon className="h-4 w-4 mr-2" />
            Add Online Source
          </Button>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Region ID</TableHead>
                <TableHead>Name</TableHead>
                <TableHead>Type</TableHead>
                <TableHead className="w-[40%]">Order Sources</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {regionConfigs.map((config) => (
                <TableRow key={config.regionId}>
                  <TableCell className="font-medium">{config.regionId}</TableCell>
                  <TableCell>{config.name}</TableCell>
                  <TableCell>{config.type}</TableCell>
                  <TableCell>
                    {config.orderSources?.join(', ')}
                  </TableCell>
                  <TableCell>
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => handleViewDetails(config.regionId)}
                    >
                      Details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <AddOnlineSourceDialog 
        open={isAddDialogOpen} 
        onOpenChange={setIsAddDialogOpen} 
        onSuccess={handleAddSuccess}
      />
    </div>
    </div>
  );
}

export default RegionConfigsPage; 
